import React from 'react';
import Icon from 'src/common/components/IconDS22';
import { NEW_TAB_ATTRIBUTES, SUPPORT_EMAIL } from 'src/common/constants';
import s from './NeedHelp.module.scss';

const NeedHelp = () => (
  <>
    <div className={s.title}>
      <Icon id="question" size="l" />
      Need help?
    </div>
    <p className={s.description}>
      Get in touch with the Customer Experience Team at
      {' '}
      <a
        href={`mailto:${SUPPORT_EMAIL}`}
        className={s.link}
        {...NEW_TAB_ATTRIBUTES}
      >
        {SUPPORT_EMAIL}
      </a>
    </p>
  </>
);

export default NeedHelp;
